(function($) {
	'use strict';

	/**
	 * Set CSS properties during the fx queue.
	 */
	$.fn.queueCSS = function() {

		var argv = [];
		for (var i = 0, ix = arguments.length; i < ix; i++) {
			argv[i] = arguments[i];
		}

		this.queue(function(next) {
			var $this = $(this);
			$this.css.apply($this, argv);
			next();
		});

		return this;

	};


	/**
	 * Add a classname during the fx queue.
	 */
	$.fn.queueAddClass = function() {

		var argv = [];
		for (var i = 0, ix = arguments.length; i < ix; i++) {
			argv[i] = arguments[i];
		}

		this.queue(function(next) {
			var $this = $(this);
			$this.addClass.apply($this, argv);
			next();
		});

		return this;

	};


	/**
	 * Remove a classname during the fx queue.
	 */
	$.fn.queueRemoveClass = function() {

		var argv = [];
		for (var i = 0, ix = arguments.length; i < ix; i++) {
			argv[i] = arguments[i];
		}

		this.queue(function(next) {
			var $this = $(this);
			$this.removeClass.apply($this, argv);
			next();
		});

		return this;

	};

}($));
